import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./en.json";

// English-only: the 26bets-style shared components read their copy through
// t("key", "English fallback"), so this keeps those files drop-in compatible.
i18n.use(initReactI18next).init({
  resources: { en: { translation: enTranslations } },
  lng: "en",
  fallbackLng: "en",
  supportedLngs: ["en"],
  // Keys are flat snake_case strings, not nested dot-paths.
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
    // Translation values use single-brace placeholders ("Continue as {name}").
    prefix: "{",
    suffix: "}",
  },
  react: { useSuspense: false },
});

export default i18n;
